import { motion } from "framer-motion";
import { Reveal } from "../Reveal";
import { FUTURE_VISION } from "../../data/content";
import { Sparkles } from "lucide-react";

export const FutureVision = () => {
  return (
    <section
      id="future-vision"
      data-testid="future-vision-section"
      className="relative bg-[#131316] py-24 lg:py-36 grain overflow-hidden"
    >
      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl mb-16">
          <Reveal>
            <span className="inline-flex items-center gap-2 text-[#e85d04] text-xs font-bold tracking-[0.28em] uppercase">
              <Sparkles size={14} /> Where This Could Go
            </span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display font-bold text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-5 leading-[1.03]">
              Future vision.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 text-lg text-white/60 font-light leading-relaxed">
              This is a concept — a starting point. Here's where the Mad Props
              Marine brand experience could grow next.
            </p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {FUTURE_VISION.map((f, i) => (
            <Reveal key={f.title} delay={(i % 4) * 0.08}>
              <motion.div
                data-testid={`vision-card-${i}`}
                whileHover={{ y: -6 }}
                transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                className="group h-full rounded-2xl border border-white/10 bg-white/[0.03] hover:bg-white/[0.06] p-6 transition-colors duration-400"
              >
                <span className="font-display font-extrabold text-[#e85d04] text-2xl">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="font-display font-semibold text-white text-lg mt-4 leading-snug">
                  {f.title}
                </h3>
                <p className="mt-2 text-sm text-white/55 font-light leading-relaxed">
                  {f.desc}
                </p>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
